<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['tweets']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Tweets Volume By Type</div>
              <v-dialog style="float: right" v-model="tweetsTypesVolumeLineChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Tweets Volume By Type</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullTweetsTypesVolumeLineChart'], 'FullTweetsTypesVolumeLineChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="tweetsTypesVolumeLineChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullTweetsTypesVolumeLineChart" ref="FullTweetsTypesVolumeLineChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top: 20px" v-if="tweetsTypesVolumeLineChartDialog">
                    <TweetsTypesVolumeLineChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTypesVolumeLineChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['TweetsTypesVolumeLineChart'], 'TweetsTypesVolumeLineChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 400px">
              <v-card-text id="TweetsTypesVolumeLineChart" ref="TweetsTypesVolumeLineChart" class="px-0" style="height: 100%">
                <TweetsTypesVolumeLineChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTypesVolumeLineChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Languages</div>
              <v-dialog style="float: right" v-model="tweetsLanguagesPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Languages</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullTweetsLanguagePieChart'], 'FullTweetsLanguagePieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="tweetsLanguagesPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullTweetsLanguagePieChart" ref="FullTweetsLanguagePieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="tweetsLanguagesPieChart">
                    <TweetsLanguagePieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsLanguagePieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['TweetsLanguagePieChart'], 'TweetsLanguagePieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="TweetsLanguagePieChart" ref="TweetsLanguagePieChart" style="height: 100%">
                <TweetsLanguagePieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsLanguagePieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Topics</div>
              <v-dialog style="float: right" v-model="tweetsTopicsPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Topics</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullTweetsTopicsPieChart'], 'FullTweetsTopicsPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="tweetsTopicsPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullTweetsTopicsPieChart" ref="FullTweetsTopicsPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="tweetsTopicsPieChart">
                    <TweetsTopicsPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTopicsPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['TweetsTopicsPieChart'], 'TweetsTopicsPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="TweetsTopicsPieChart" ref="TweetsTopicsPieChart" style="height: 100%">
                <TweetsTopicsPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTopicsPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-toolbar class="elevation-1 secondary" >
          <v-toolbar-side-icon><v-icon>fab fa-twitter</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>Tweets</v-toolbar-title>
          <v-spacer></v-spacer>
          
          <v-flex xs2>
            <v-select
              v-model="sortBy"
              :items="tweetSort"
              hide-details
              item-text="text"
              item-value="value"
              label="Sort by"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }"
              >
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-tooltip bottom>
            <v-avatar slot="activator">
              <v-icon v-bind:class="[orderBy === 'ASC' ? 'ascending' : 'descending']" @click="orderChange">arrow_downward</v-icon>
            </v-avatar>
            <span>Ascending / Descending Order</span>
          </v-tooltip>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-0">
            <center>
              <TweetsListing v-bind:options="{sortBy: sortBy, orderBy: orderBy, latest: getShowLatestCountersForTweets}" v-bind:filters="getFilters"></TweetsListing>
            </center>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
  .ascending {
    transform: rotate(-180deg);
    transition: 0.2s all ease-in-out;
  }
  .descending {
    transform: rotate(0deg);
    transition: 0.2s all ease-in-out;
  }
</style>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import TweetsTypesVolumeLineChart from './charts/TweetsTypesVolumeLineChart.vue'
import TweetsListing from './listings/TweetsListing.vue'
import TweetsLanguagePieChart from './charts/TweetsLanguagePieChart.vue'
import TweetsTopicsPieChart from './charts/TweetsTopicsPieChart.vue'

export default {
  data () {
    return {
      tweetSort: [
        {color: 'gray lighten-2', icon: 'fas fa-users', text: 'Followers', value: '_user_followers_count'},
        {color: 'green lighten-2', icon: 'fas fa-retweet', text: 'Retweet', value: '_retweet_count'},
        {color: 'red lighten-2', icon: 'fas fa-heart', text: 'Favorite', value: '_favorite_count'},
        {color: 'blue lighten-2', icon: 'fas fa-comment', text: 'Reply', value: '_reply_count'},
        {color: 'teal lighten-2', icon: 'fas fa-quote-right', text: 'Quote Tweet', value: '_quote_count'},
        {color: 'purple lighten-2', icon: 'fas fa-bullhorn', text: 'Impressions', value: '_impression_count'},
        {color: 'orange lighten-2', icon: 'fas fa-calendar', text: 'Date', value: '_created_at'}
      ],
      sortBy: '_retweet_count',
      orderBy: 'DESC',
      expansionValue: 0,
      tweetsTopicsPieChart: false,
      tweetsLanguagesPieChart: false,
      tweetsTypesVolumeLineChartDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters']),
    ...mapGetters('toggles', ['getFiltersChips', 'getShowLatestCountersForTweets'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap,
    orderChange () {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
    }
  },
  components: {
    Filters,
    Counters,
    TweetsTypesVolumeLineChart,
    TweetsListing,
    TweetsLanguagePieChart,
    TweetsTopicsPieChart
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Tweets.vue